export default "__VITE_ASSET__01e53d81__"